export const clearError = ($el) => {
  const $field = $el.closest(".field");

  if (!$field) return;

  const $errorMessage = $field.querySelector(".help.is-danger");
  if ($errorMessage) $errorMessage.remove();

  const $errors = $field.querySelector(".is-danger");
  if ($errors) $errors.classList.remove("is-danger");
};
